import ProjectTabOverview from '../ProjectTabOverview';
import RequiredTab from '../RequiredTab';
import { ESTABLISHMENT_TYPE } from '../ProjectTypeSelect/utils';
import ProjectTab from '../ProjectTab';
import SiteTab from '../SiteTab';
import ProjectTabImproveSolutions from '../ProjectTabImproveSolutions';
import ResponsibleTab from '../ResponsibleTab';
import CapacityTab from '../CapacityTab';
import StatusesTab from '../StatusesTab';
import ProjectTabFinancials from '../ProjectTabFinancials';
import ProjectTabDp from '../ProjectTabDP';
import { CompleteTabsConfig } from '../../models/reusableProps/TabConfig';
import { ReturnTabConfigProps } from '../../models/reusableProps/ReturnTabConfigProps';
import ConfidentialUsersTab from '../ConfidentialUsersTab';
import { AD, roleRestricted, SA } from '../RoleRestricted/utils';
import ActivityLogTab from '../ActivityLogTab';

export const returnTabConfig: ReturnTabConfigProps = (
  t,
  project,
  countries,
  projectsList,
  setActiveProject,
  usersList,
  BuList,
  isConfidentialAllowed,
  isEdit,
  onCountryChange,
  isep,
  onBUChange,
  programName,
  isConfidential = false,
  userRole,
  onShowDirective,
) => {
  const tabList = [
    {
      value: 'Required',
      label: isEdit ? t('tabs.overview') : t('tabs.required'),
    },
    {
      value: 'Project',
      label: t('tabs.project'),
    },
    {
      value: 'Site/Unit',
      label: t('tabs.siteUnit'),
    },
    {
      value: 'Solutions',
      label: t('tabs.solutions'),
    },
    {
      value: 'Responsible',
      label: t('tabs.responsible'),
    },
    {
      value: 'Capacity',
      label: t('tabs.capacity'),
    },
    {
      value: 'Statuses',
      label: t('tabs.statuses'),
    },
    {
      value: 'Financials',
      label: t('tabs.financials'),
    },
  ];
  if (isConfidential && roleRestricted([AD, SA], userRole)) {
    tabList.splice(5, 0, {
      value: 'ConfidentialUsers',
      label: t('tabs.confidentialUsers'),
    });
  }
  const panelsList = [
    {
      value: 'Required',
      dataTestID: isEdit ? 'overview-tab-content' : 'required-tab-content',
      component: isEdit ? (
        <ProjectTabOverview
          project={project}
          setActiveProject={setActiveProject}
          onViewDirective={onShowDirective}
        />
      ) : (
        <RequiredTab
          tabType={ESTABLISHMENT_TYPE.IMPROVE}
          countries={countries}
          isConfidentialAllowed={isConfidentialAllowed}
          usersList={usersList}
          BUList={BuList}
          onCountryChange={onCountryChange}
          onBUChange={onBUChange}
        />
      ),
    },
    {
      value: 'Project',
      dataTestID: 'project-tab-content',
      component: (
        <ProjectTab
          tabType={ESTABLISHMENT_TYPE.IMPROVE}
          isRealEstateSisan={isEdit && project.realEstateSISAN}
          projectList={projectsList}
          isConfidentialAllowed={isConfidentialAllowed}
          isep={isep}
          programName={programName}
        />
      ),
    },
    {
      value: 'Site/Unit',
      dataTestID: 'site-unit-tab-content',
      component: (
        <SiteTab
          tabType={ESTABLISHMENT_TYPE.IMPROVE}
          countries={countries}
          BuList={BuList}
          onCountryChange={onCountryChange}
          onBUChange={onBUChange}
          isEdit={isEdit}
        />
      ),
    },
    {
      value: 'Solutions',
      dataTestID: 'solutions-tab-content',
      component: <ProjectTabImproveSolutions />,
    },
    {
      value: 'Responsible',
      dataTestID: 'responsible-tab-content',
      component: (
        <ResponsibleTab
          tabType={ESTABLISHMENT_TYPE.IMPROVE}
          usersList={usersList}
        />
      ),
    },
    {
      value: 'ConfidentialUsers',
      dataTestID: 'confidential-users-tab-content',
      component: <ConfidentialUsersTab usersList={usersList} />,
    },
    {
      value: 'Capacity',
      dataTestID: 'capacity-tab-content',
      component: <CapacityTab tabType={ESTABLISHMENT_TYPE.IMPROVE} />,
    },
    {
      value: 'Statuses',
      dataTestID: 'statuses-tab-content',
      component: (
        <StatusesTab tabType={ESTABLISHMENT_TYPE.IMPROVE} isEdit={isEdit} />
      ),
    },
    {
      value: 'Financials',
      dataTestID: 'financials-tab-content',
      component: <ProjectTabFinancials />,
    },
  ];

  if (isEdit) {
    tabList.push({
      value: 'DP',
      label: t('tabs.dp'),
    });
    panelsList.push({
      value: 'DP',
      dataTestID: 'dp-tab-content',
      component: <ProjectTabDp decisionPoints={project?.decisionPoints} />,
    });
    tabList.push({
      value: 'ActivityLog',
      label: t('tabs.activityLog'),
    });
    panelsList.push({
      value: 'ActivityLog',
      dataTestID: 'activity-log-tab-content',
      component: <ActivityLogTab projectId={project.id} />,
    });
  }
  return { tabList, panelsList } as CompleteTabsConfig;
};
